var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseOrderModal',{attrs:{"orderUUID":_vm.OrderNumber,"value":true,"inline":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }